// The QR table pin — scanning /t/{tableId} seats the session at that table.
// One pin per store; changing tables keeps the cart (v3 semantics).

export type PinnedTable = { storeKey: string; tableId: string; tableName: string };

const KEY = 'rp-order-table';

export function pinnedTable(storeKey: string): PinnedTable | null {
  const raw = sessionStorage.getItem(KEY);
  if (!raw) return null;
  try {
    const t = JSON.parse(raw) as PinnedTable;
    return t.storeKey === storeKey ? t : null;
  } catch {
    return null;
  }
}

export function pinTable(pin: PinnedTable): void {
  sessionStorage.setItem(KEY, JSON.stringify(pin));
}

export function unpinTable(): void {
  sessionStorage.removeItem(KEY);
}
